import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckAccessDirective } from './check-access.directive';
import { OnlyNumbersDirective } from './only-numbers.directive';

@NgModule({
  declarations: [CheckAccessDirective, OnlyNumbersDirective],
  imports: [CommonModule],
  exports: [CheckAccessDirective, OnlyNumbersDirective],
})
export class DirectiveModule {}
